import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { exposeAppVersion } from './version';

// Round25 · M7：任何构建都在启动时暴露版本信息（window.__APP_VERSION__ + <html data-app-commit>），
// 保证真机「随手可查」当前部署 commit，且不受调试门控（非调试能力）。
exposeAppVersion();

const el = document.getElementById('root');
if (!el) throw new Error('找不到 #root 挂载点');

createRoot(el).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
